import { Button, Space } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { Country } from "../../shared/dtos/country";

interface ColumnActions {
  handleEdit: (record: Country) => void;
}

export const columns = (actions?: ColumnActions): ColumnsType<Country> => [
  {
    title: "ID",
    dataIndex: "id",
    width: "10%",
  },
  {
    title: "Nombre",
    dataIndex: "name",
    width: "30%",
  },
  {
    title: "ISO",
    dataIndex: "iso",
    width: "10%",
    render: (iso: string) => iso ?? "-",
  },
  {
    title: "Moneda",
    dataIndex: "currency",
    width: "15%",
    render: (currency: string) => currency ?? "-",
  },
  {
    title: "Acciones",
    width: "15%",
    render: (_: any, record: Country) => (
      <Space>
        <Button type="link" icon={<EditOutlined />} onClick={() => actions?.handleEdit(record)} />
      </Space>
    ),
  },
];
